import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import challengesData from '../challenges/challenges.json';
import WebExploitationChallenge from '../components/challenge-components/WebExploitationChallenge';
import SteganographyChallenge from '../components/challenge-components/SteganographyChallenge';
import TerminalChallenge from '../components/challenge-components/TerminalChallenge';
import CryptographyChallenge from '../components/challenge-components/CryptographyChallenge';
import BinaryExploitationChallenge from '../components/challenge-components/BinaryExploitationChallenge';
import ReverseEngineeringChallenge from '../components/challenge-components/ReverseEngineeringChallenge';
import NetworkingChallenge from '../components/challenge-components/NetworkingChallenge';
import OSINTChallenge from '../components/challenge-components/OSINTChallenge';
import ForensicsChallenge from '../components/challenge-components/ForensicsChallenge';
import SocialEngineeringChallenge from '../components/challenge-components/SocialEngineeringChallenge';

// Import Header component
import Header from '../components/Header';

function ChallengePage({ user }) {
  const { id } = useParams();
  const [challenge, setChallenge] = useState(null);

  useEffect(() => {
    const selectedChallenge = challengesData.challenges.find((ch) => ch.id === id);
    setChallenge(selectedChallenge);
  }, [id]);

  if (!challenge) return <div className="p-8 text-textWhite">Loading...</div>;

  return (
    <div>
      {/* Display the Header */}
      <Header user={user} />

      {/* Challenge content */}
      <div className="p-8 bg-darkBackground min-h-screen">
        <h2 className="text-3xl font-bold text-cyberBlue mb-4">{challenge.name}</h2>
        <p className="text-xl mb-4 text-textWhite">{challenge.description}</p>

        {/* Container for the masonry grid */}
        <div className="masonry-grid">
          {challenge.type === 'web' && <WebExploitationChallenge challenge={challenge} />}
          {challenge.type === 'steganography' && <SteganographyChallenge challenge={challenge} />}
          {challenge.type === 'terminal' && <TerminalChallenge challenge={challenge} />}
          {challenge.type === 'cryptography' && <CryptographyChallenge challenge={challenge} />}
          {challenge.type === 'binary_exploitation' && <BinaryExploitationChallenge challenge={challenge} />}
          {challenge.type === 'reverse_engineering' && <ReverseEngineeringChallenge challenge={challenge} />}
          {challenge.type === 'networking' && <NetworkingChallenge challenge={challenge} />}
          {challenge.type === 'osint' && <OSINTChallenge challenge={challenge} />}
          {challenge.type === 'forensics' && <ForensicsChallenge challenge={challenge} />}
          {challenge.type === 'social_engineering' && <SocialEngineeringChallenge challengeId={id} />}
        </div>
      </div>
    </div>
  );
}

export default ChallengePage;
